module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.no_assertion_found === 'true') ? _c('div', [_c('h2', {
    staticClass: "heading",
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_c('br'), _vm._v(" "), _c('span', {
    style: ({
      color: _vm.getCorpHeadingColor
    })
  }, [_vm._v("To access TONE, navigate to the Learning Homepage in Workday"), _c('br'), _vm._v("and click on the TONE Networks link.")]), _vm._v(" "), _c('br'), _c('br')])]) : _vm._e()
},staticRenderFns: []}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-764e8160"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_live_NgwNoBs3GAlrsSez07Zyh4Jc"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www.tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/assets.tonenetworks.com/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/HorizonssoTemp.vue